import logic1 from './1.js';
import logic102 from './102.js';
import logic103 from './103.js';
import logic104 from './104.js';
import logic105 from './105.js';
import logic106 from './106.js';
import logic107 from './107.js';
import logic108 from './108.js';
import logic109 from './109.js';

const logicFiles = [
  logic1,
  logic102,
  logic103,
  logic104,
  logic105,
  logic106,
  logic107,
  logic108,
  logic109
];

export const checkReason = (name) => {
  if (!name || typeof name !== 'string') {
    return { error: 'Name must be a string' };
  }

  if (!/^[a-zA-Z\s]+$/.test(name)) {
    return { error: 'Only alphabets and spaces allowed! ❌' };
  }

  for (const logicFn of logicFiles) {
    const result = logicFn(name.trim());
    if (result) return { reason: result };
  }

  return { reason: 'No Thala reason found, but keep trying! 🤷‍♂️' };
};
